export const PIPELINE_PAGINATION_ERROR_CODE =
  'PIPELINE_PAGINATION_CURSOR_INVALID';

export class PipelinePaginationError extends Error {
  constructor(message = 'Pipeline pagination cursor is invalid', details = {}) {
    super(message);
    this.name = 'PipelinePaginationError';
    this.code = PIPELINE_PAGINATION_ERROR_CODE;
    this.details = details;
  }
}

export const requireNextPipelineCursor = (nextCursor, seenCursors, message) => {
  if (!nextCursor) {
    throw new PipelinePaginationError(message, { reason: 'missing_cursor' });
  }

  const cursorKey = String(nextCursor);
  if (seenCursors.has(cursorKey)) {
    throw new PipelinePaginationError(message, {
      reason: 'repeated_cursor',
      cursor: cursorKey,
    });
  }

  seenCursors.add(cursorKey);
  return nextCursor;
};
